import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./item-servico-listar/item-servico-listar.module').then(m => m.ItemServicoListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./item-servico-inserir/item-servico-inserir.module').then(m => m.ItemServicoInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./item-servico-editar/item-servico-editar.module').then(m => m.ItemServicoEditarModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./item-servico-detalhar/item-servico-detalhar.module').then(m => m.ItemServicoDetalharModule) }

    
    ])],
    exports: [RouterModule]
})
export class ItemServicoAppRoutingModule { }